<template>
  <div>
    <v-select
      :value="autoGeneratedStatus"
      :items="searchAutoGeneratedStatus"
      @change="onChange"
      class="select-box"
    />
  </div>
</template>

<script>
export default {
  name: 'SearchAutoGenerateStatus',
  data() {
    return {
      autoGeneratedStatus: null,
      searchAutoGeneratedStatus: [
        { value: null, text: 'すべて' },
        { value: true, text: '自動発行' },
        { value: false, text: '手動発行' },
      ],
    }
  },
  methods: {
    onChange(status) {
      this.autoGeneratedStatus = status
      this.$emit('onAutoGenerateStatusChange', this.autoGeneratedStatus)
    },
  },
}
</script>

<style>
.select-box {
  max-width: 150px;
}
</style>
